import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Modal viewer for PDF (native iframe) and video (HTML5) via the authenticated
// same-origin /view endpoint — no public link needed, works for all roles.
export default function FileViewer({ viewUrl, file, onClose }) {
  if (!file) return null;
  const ext = (file.original_filename || "").split(".").pop().toLowerCase();
  const isVideo = ["mp4", "mov", "webm"].includes(ext);
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-5xl w-[95vw] h-[85vh] flex flex-col p-4" data-testid="file-viewer-modal">
        <DialogHeader>
          <DialogTitle className="text-sm truncate pr-8">{file.document_name || file.original_filename}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0 mt-2 bg-slate-900 rounded-md overflow-hidden">
          {isVideo ? (
            <video src={viewUrl} controls autoPlay className="w-full h-full" data-testid="file-viewer-video" />
          ) : (
            <iframe src={viewUrl} title={file.original_filename} className="w-full h-full bg-white" data-testid="file-viewer-iframe" />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
